import React, { useContext, forwardRef } from 'react'
import { NavLink } from 'react-router-dom'
import useUtils from '../../../../hooks/useUtils'
import PropTypes from 'prop-types'
import Icon from './Icons'
import { context } from '../../../../Layout'
import './styles.scss'
import clsx from 'clsx'

const Button = forwardRef(
  (
    {
      link,
      isSubmit,
      name,
      className,
      icon,
      iconWidth,
      iconHeight,
      iconFill,
      iconStroke,
      strokeOnHover = 'white',
      showLabel,
      action,
      type = 'button',
      isDisabled,
      strokeCircle,
      variant,
      light = false,
      target = '_self',
    },
    ref,
  ) => {
    const { convertToRelative } = useUtils()
    const { lenisInstance } = useContext(context)

    const scrollToSection = (section) => {
      lenisInstance.scrollTo(section, { offset: -200 })
    }

    const renderContent = () => {
      if (showLabel) return <span dangerouslySetInnerHTML={{ __html: name }} />
    }

    if (type === 'icon') {
      return (
        <button
          ref={ref}
          className={`button-icon ${className}`}
          onClick={action || null}
          disabled={isDisabled}
        >
          <Icon
            name={icon}
            width={iconWidth}
            height={iconHeight}
            fill={iconFill}
            stroke={iconStroke}
            strokeOnHover={strokeOnHover}
            strokeCircle={strokeCircle}
          />
        </button>
      )
    }

    if (isSubmit) {
      return (
        <button
          ref={ref}
          type={type}
          onClick={action || null}
          className={clsx(
            light ? 'button-light' : 'button',
            className ? className : '',
            variant === 'filled' && light ? 'button-filled-light' : 'button-filled',
          )}
          disabled={isDisabled}
        >
          {renderContent()}
        </button>
      )
    }

    if (link) {
      const isAnchorLink = link.startsWith('#')

      if (isAnchorLink) {
        return (
          <button
            ref={ref}
            className={clsx(
              light ? 'button-light' : 'button',
              className ? className : '',
              variant === 'filled' && light ? 'button-filled-light' : 'button-filled',
            )}
            onClick={() => scrollToSection(link)}
          >
            {renderContent()}
          </button>
        )
      }

      return (
        <NavLink
          ref={ref}
          target={target}
          className={clsx(
            light ? 'button-light' : 'button',
            className ? className : '',
            variant === 'filled' && light ? 'button-filled-light' : 'button-filled',
          )}
          to={convertToRelative(link)}
        >
          {renderContent()}
        </NavLink>
      )
    } else if (link === '') {
      return (
        <button
          ref={ref}
          className={clsx(
            light ? 'button-light' : 'button',
            className ? className : '',
            variant === 'filled' && light ? 'button-filled-light' : 'button-filled',
          )}
          onClick={action || null}
        >
          {renderContent()}
        </button>
      )
    }

    return null
  },
)

Button.propTypes = {
  link: PropTypes.string,
  isSubmit: PropTypes.bool,
  name: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.oneOf(['ArrowRight', 'ArrowLeft']),
  iconWidth: PropTypes.string,
  iconHeight: PropTypes.string,
  iconFill: PropTypes.string,
  iconStroke: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'icon']),
  variant: PropTypes.oneOf(['filled', 'default']),
  showLabel: PropTypes.bool,
  action: PropTypes.func,
  isDisabled: PropTypes.bool,
  strokeCircle: PropTypes.string,
  light: PropTypes.bool,
  target: PropTypes.string,
}

Button.default = {
  link: '',
  isSubmit: false,
  name: 'test',
  className: '',
  icon: 'ArrowRight',
  iconWidth: '58px',
  iconHeight: '58px',
  iconFill: 'none',
  iconStroke: '#1B1F24',
  showLabel: false,
  action: () => {},
  type: 'button',
  isDisabled: false,
  strokeCircle: '#1B1F24',
  variant: 'default',
  light: false,
  target: '_self',
}

export default Button
